import { render } from "./Holder1.vue?vue&type=template&id=32ffe339&scoped=true"
import script from "./Holder1.vue?vue&type=script&lang=js"
export * from "./Holder1.vue?vue&type=script&lang=js"

import "./Holder1.vue?vue&type=style&index=0&id=32ffe339&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32ffe339"]])

export default __exports__